module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "accordion"
  }, [(!!_vm.oneFormName) ? [_c('div', {
    staticClass: "accordion__items accordion__items_border"
  }, [_c('div', {
    staticClass: "accordion__tab accordion__tab_active"
  }, [_c('h2', {
    staticClass: "accordion__header"
  }, [_vm._v(_vm._s(_vm.oneFormName))])]), _c('div', {
    staticClass: "accordion__content"
  }, [_vm._t("default")], 2)])] : _vm._l((_vm.list), function(ref, index) {
    var name = ref.name;
    var id = ref.id;

    return _c('div', {
      key: index,
      staticClass: "accordion__items"
    }, [_c('div', {
      staticClass: "accordion__tab",
      class: {
        accordion__tab_active: _vm.flag == index
      },
      on: {
        "click": function($event) {
          return _vm.showContent(index, id)
        }
      }
    }, [_c('h2', {
      staticClass: "accordion__header"
    }, [_vm._v(_vm._s(name))]), _c('div', {
      staticClass: "accordion__icon"
    })]), (_vm.flag == index) ? _c('div', {
      key: index,
      staticClass: "accordion__content"
    }, [_vm._t("default")], 2) : _vm._e()])
  })], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ad32f122","hasScoped":true,"preserveWhitespace":false}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/accordion/Accordion.vue
// module id = aec8af3d0b0e8e7cf407
// module chunks = 5